const state = {
  organizationUsers: [],
  loading: false,
  errors: {},
}

const getters = {
  organizationUsers: (state) => state.organizationUsers,
  loading: (state) => state.loading,
  errors: (state) => state.errors,
}

const actions = {
  async fetchOrganizationUsers({ commit }, params) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERRORS')

    let { payload, id } = params

    try {
      const response = await this._vm.$api.get('/organization/users', { params: payload })
      commit('SET_ORGANIZATION_USERS', response.data.data)
      return response
    } catch (error) {
      commit('SET_ERRORS', error.response?.data?.errors || {})
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateUserRole({ commit }, { organization_id, user_id, role }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERRORS')

    try {
      const response = await this._vm.$api.post('/organization/users/update-role', {
        organization_id,
        user_id,
        role
      })
      return response
    } catch (error) {
      commit('SET_ERRORS', error.response?.data?.errors || {})
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async removeOrganizationUser({ commit }, { organization_id, user_id }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERRORS')

    try {
      const response = await this._vm.$api.delete('/organization/users/remove', {
        data: {
          organization_id,
          user_id
        }
      })
      return response
    } catch (error) {
      commit('SET_ERRORS', error.response?.data?.errors || {})
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
}

const mutations = {
  SET_ORGANIZATION_USERS(state, users) {
    state.organizationUsers = users
  },

  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_ERRORS(state, errors) {
    state.errors = errors
  },

  CLEAR_ERRORS(state) {
    state.errors = {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
